var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RouteListItem',{attrs:{"node":{
  name: _vm.node.name,
  children: _vm.isAdmin ? _vm.assignments : [],
  meta: {
    displayName: _vm.isAdmin ? _vm.$t('servicesystem.pages.page_titles.job_assignments') : _vm.$t('servicesystem.pages.page_titles.job_my_jobs'),
    icon: _vm.isAdmin ? 'mdi-account-group' : 'mdi-briefcase-account',
    count: _vm.isAdmin ? 0 : _vm.myUserCount,
    params: {
      filter: "my",
    }
  }
},"openfunc":function () { return (_vm.$route.name == _vm.node.name && _vm.$route.params.filter == 'y') }},on:{"open":function($event){return _vm.refreshMap()}}},[(_vm.isAdmin)?_c('template',{slot:"children"},[(_vm.loading)?_c('v-progress-linear',{attrs:{"indeterminate":"","height":"1"}}):_vm._e(),_c('RouteListItem',{key:_vm.myUserId,attrs:{"node":{
      name: _vm.node.name,
      meta: {
        displayName: _vm.$t('servicesystem.pages.page_titles.job_my_jobs'),
        count: _vm.myUserCount,
        params: { filter: "my" },
      }
    }}},[_c('template',{slot:"icon"},[_c('avatar',{attrs:{"color":'red',"fullname":_vm.userInfo.Name,"xSmall":true}})],1)],2),_vm._l((_vm.othersAssignments),function(user){return _c('RouteListItem',{key:user.Id,attrs:{"node":{
      name: _vm.node.name,
      meta: {
        displayName: user.Name,
        count: user.Count,
        params: { filter: ("user-" + (user.Id)) },
      }
    }}},[_c('template',{slot:"icon"},[_c('avatar',{attrs:{"color":_vm.getUserTypeColor(user.UserTypeId),"fullname":user.Name,"xSmall":true}})],1)],2)})],2):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }